import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { Check as CheckIcon } from "@remo-co/ui-core/src/icons/Check";
import classNames from "classnames";
import { useI18n } from "i18n";
import { ChangeEvent } from "react";
import { ActivityStatus } from "../../types";
import { useStyles } from "./styles";

interface Props {
  status: ActivityStatus;
  label: string;
  onChange: (status: ActivityStatus, label: string) => void;
}

export const SetActivityStatusDialog = ({ status, label, onChange }: Props) => {
  const { t } = useI18n(["event"]);
  const styles = useStyles();

  return (
    <Container className={styles.container}>
      {Object.values(ActivityStatus).map((mappedStatus) => (
        <Button
          onClick={() => {
            onChange(mappedStatus, label);
          }}
          data-testid={`${mappedStatus}-status-button`}
          isIconButton
          className={classNames(styles.statusButtons, {
            [styles.selected]: status === mappedStatus,
          })}
          contentClassName={styles.statusButtonContent}
          color="dark"
          variant="ghost"
          size="md"
        >
          {status === mappedStatus ? (
            <CheckIcon
              className={styles.checkIcon}
              data-testid={`status-${mappedStatus}-selected`}
            />
          ) : (
            <div
              className={classNames(
                styles.statusDots,
                styles[`${mappedStatus}StatusDot`],
              )}
              data-testid={`status-${mappedStatus}`}
            />
          )}
          <Typography variant="body1" color="textPrimary">
            {t(`event:activity.status.${mappedStatus}`)}
          </Typography>
        </Button>
      ))}
      <Input
        id="custom-label"
        fullWidth
        size="sm"
        placeholder={t("event:add.custom.message")}
        value={label}
        onChange={(evt: ChangeEvent<HTMLInputElement>) => {
          onChange(status, evt.target.value);
        }}
        getRemainingCharsMessage={(key) =>
          t("common:character.remaining", { key })
        }
        inputProps={{ maxLength: 30 }}
      />
    </Container>
  );
};
